module.exports = __webpack_public_path__ + "static/media/abacus.9caf7520.svg";